var React = require('react');

function Messages (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"className":"stroke","transform":"translate(-718.000000, -2701.000000)","stroke":"#F2C1B6","strokeWidth":"2"},React.createElement("g",{"transform":"translate(720.000000, 2224.000000)"},React.createElement("g",{"transform":"translate(0.000000, 147.000000)"},React.createElement("g",{"transform":"translate(0.000000, 297.000000)"},React.createElement("g",{"transform":"translate(0.000000, 34.000000)"},React.createElement("polygon",{"points":"0 283.427246 12.4419556 -1.2180144e-14 527 -1.2180144e-14 514.214481 119.946299 535.642896 119.946299 527 264.543579"}))))))));
}

Messages.defaultProps = {"preserveAspectRatio":"none","width":"539px","height":"286px","viewBox":"0 0 539 286","version":"1.1"};

module.exports = Messages;

Messages.default = Messages;
